export default "__VITE_ASSET__Cn_sx$NB__"